import { EuiThemeModifications } from '@elastic/eui'

export const THEME: EuiThemeModifications = {
    font: {
        family: '"Noto Sans", sans-serif',
    },
    colors: {},
}
